import { UserStatusDto } from '@tradgine/data-access/auth';
import { UserStatus } from '../domain/user-status';

export const toUserStatus = (dto: UserStatusDto): UserStatus => dto;
